<template>
    <div class="container">
        <h5 class="title is-5">Logging out...</h5>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

  export default {
    name: "screen404",
    methods: {
      ...mapActions('auth', ['logout'])
    },
    mounted() {
      this.logout();
    }
  }
</script>

<style scoped>

</style>